import { CSSObject } from '@chakra-ui/react';
import volleyball from '../../../../../assets/wellbet/images/toggle/volleyball.svg';

export const FlexWrapper = {
  borderRadius: 'base',
  contain: 'layout',
  alignItems: 'center',
  justifyContent: 'center',
  p: '2',
  mx: ['1.5', null, null, 'unset'],
  mb: ['1', null, null, '2.5'],
  gap: '2',

  boxShadow: 'md',
  bg: ['gamma.500', null, 'white'],
};

export const TextToggle = (isActive: boolean) => ({
  fontSize: 'sm',
  p: '2',
  flex: [1, 'unset'],

  borderRadius: 'full',
  textTransform: 'uppercase',
  fontWeight: 'semibold',
  letterSpacing: '1px',
  px: '5',
  py: '1',
  maxW: '110px',
  textAlign: 'center',
  transition: 'all, 0.2s linear',
  color: ['yellow.900', null, 'alpha.600'],

  // This is just a placeholder
  ...(isActive && {
    color: ['yellow.900', null, 'alpha.600'],
  }),
  ...(!isActive && {
    color: ['yellow.900', null, 'alpha.600'],
  }),
});

export const Switcher = (): CSSObject => ({
  bg: 'transparent',

  '.chakra-switch__thumb': {
    bgImage: `url(${volleyball})`,
    bgSize: '100%',
    boxShadow: '1px 0px 3px',
  },
  '.chakra-switch__track': {
    boxShadow: 'inset 0px 3px 3px rgba(0, 0, 0, 0.3)',
    bg: ['gamma.900', null, 'alpha.700'],
  },

  _checked: {
    bg: 'transparent',

    '.chakra-switch__track': {
      boxShadow: 'inset 0px 3px 3px rgba(0, 0, 0, 0.3)',
      bg: ['gamma.900', null, 'alpha.700'],
    },
  },
});
